import EmailGroupList from "../components/email-group/EmailGroupCrud";

const EmailGroupPage = () => {
  return <EmailGroupList />;
};

export default EmailGroupPage;
